import React, { useState } from 'react';
import { Dropdown, FormControl } from 'react-bootstrap';
import InfoMessage from 'src/containers/QuestionnaireParent/QuestionOptionsLibrary/components/InfoMessage/InfoMessage';
import './DropdownField.scss';
import { Choices } from '../../types/TherapistAvailabilityWidget';

type DropdownFieldType = {
  className: string;
  onChangeValue: (newValue: Choices) => void;
  menu: Array<Choices>;
  title?: string;
  infoMessage?: string;
  isActivityLog?: boolean;
  dropDownDisabled?: boolean;
};

const DropdownField: React.FC<DropdownFieldType> = ({
  className,
  onChangeValue,
  menu,
  title,
  infoMessage,
  isActivityLog = false,
  dropDownDisabled = false,
}) => {
  const [selectedValue, setSelectedValue] = useState<Choices | null>(
    (menu && menu?.length && menu?.find(m => m.selected)) ||
      (isActivityLog ? menu[0] : null),
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [showMenu, setShowMenu] = useState(false);

  const displayTitle =
    selectedValue && selectedValue?.label ? (
      <span className='selected_value'>{selectedValue?.label}</span>
    ) : (
      title
    );

  const onInputChange = (newValue: Choices | null) => {
    if (newValue) {
      setSelectedValue(newValue);
      onChangeValue(newValue || {});
      setShowMenu(false);
    }
  };

  const filteredMenu = menu
    .filter((option: Choices) => {
      const lowerCaseTitle = option?.label?.toLowerCase();
      const lowerCaseSearchTerm = searchTerm.toLowerCase();

      return (
        lowerCaseTitle?.startsWith(lowerCaseSearchTerm) ||
        lowerCaseTitle?.includes(lowerCaseSearchTerm)
      );
    })
    .sort((a: Choices, b: Choices) => {
      const aStartsWith = a?.label
        .toLowerCase()
        .startsWith(searchTerm.toLowerCase());
      const bStartsWith = b?.label
        .toLowerCase()
        .startsWith(searchTerm.toLowerCase());

      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;

      return 0;
    });

  const renderOptions = () =>
    filteredMenu.map((option: Choices, index: number) => (
      <Dropdown.Item
        key={index}
        onClick={() => onInputChange(option)}
        active={option === selectedValue}
      >
        {option.label}
      </Dropdown.Item>
    ));

  const onFocusOut = () => {
    if (!selectedValue && isActivityLog){
      setSelectedValue(menu[0]);
    }
  };
  
  return(
    menu && (
      <div
        className={`dropdown_menu_field_container ${className} ${
          isActivityLog && 'active_log_dropdown_menu'
        }`}
      >
        <Dropdown
          onToggle={isOpen => setShowMenu(isOpen)}
          show={showMenu}
          autoFocus={true}
          onBlur={onFocusOut}
        >
          <Dropdown.Toggle
            variant="success"
            id="dropdown-basic"
            disabled={dropDownDisabled}
          >
            {showMenu ? (
              <FormControl
                autoFocus={true}
                className="dropdown_menu_placeholder_div"
                placeholder="Type to search..."
                onChange={e => setSearchTerm(e.currentTarget.value)}
                value={searchTerm}
              />
            ) : (
              <div className="dropdown_menu_display_title_div">
                {displayTitle || 'Select an option'}
              </div>
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu>{renderOptions()}</Dropdown.Menu>
        </Dropdown>
        {infoMessage && <InfoMessage text={infoMessage} />}
      </div>
    )
  );
};

export default DropdownField;
